import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            label_inicio: "Home",
            label_contacto: "Contact",
            label_iniciar_sesion: "Log in",
            label_plataforma_de_nutricion: "English for learners worldwide",
            label_ingresa_tus_credenciales_para_continuar: "Enter your credentials to continue",
            label_usuario: "Username",
            label_ingresa_tu_usuario: "Enter your username",
            label_contrasena: "Password",
            label_ingresa_tu_contrasena: "Enter your password",
            label_ingresar: "Sign in",
            label_volver_al_inicio: "Back to home",
            label_cargando: "Loading…",
            label_manage_applicant: "Manage applicants",
            label_administra_la_lista_de_applicants: "Administra la lista de applicants",
            label_nuevo: "New",
            label_buscar: "Search",
            label_estado: "Status",
            label_showing: "Showing",
            label_of: "of",
            label_records: "records",
            label_no_records: "No records",
            label_previous: "Previous",
            label_page: "Page",
            label_code: "Code",
            label_name: "Name",
            label_phone_number: "Phone number",
            label_email_address: "Email address",
            label_date_start: "Date start",
            label_expectation: "Expectation",
            label_modify_applicant: "Modify applicant",
            label_tuttie_english: "Tuttie English",

            alert_usuario_o_contrasena_incorrecto: "Incorrect username or password",
            alert_procesando_solicitud: "Processing…",
            alert_fecha_invalida: "Please enter a valid date.",
            cal_today: "Today",
            cal_placeholder_select: "Select date (MM-DD-YYYY)",

            menu_dashboard: "Dashboard",
            menu_administracion: "Administration",
            menu_applicants: "Applicants",
            menu_salir: "Log out",

            te_brand: "Tutti English",
            te_nav_specialties: "Specialties",
            te_nav_accent: "Accent & speech",
            te_nav_how: "How it works",
            te_nav_join: "Register",
            te_hero_badge: "Kids, adults & professionals",
            te_hero_title: "Learn English —",
            te_hero_title_highlight: "clear accent, real confidence",
            te_hero_subtitle:
                "Online lessons tailored to how you speak today and how you want to sound tomorrow. Medical, tech, creative fields, and everyday fluency — with teachers who match your goals.",
            te_hero_cta_form: "Start with the form",
            te_hero_cta_whatsapp: "Chat on WhatsApp",
            te_hero_secondary: "Explore specialties",

            te_sectors_title: "English that fits your world",
            te_sectors_subtitle:
                "We pair you with teachers who know the vocabulary and scenarios you actually use — not only generic textbook English.",
            te_sector_medical_title: "Medical & healthcare",
            te_sector_medical_desc:
                "Pronunciation and technical language for consultations, charts, teamwork, and patient communication.",
            te_sector_it_title: "IT & engineering",
            te_sector_it_desc:
                "Stand-ups, documentation, interviews, and client calls — clear structure and natural pace.",
            te_sector_music_title: "Music & creative",
            te_sector_music_desc:
                "Studio talk, touring, interviews, and collaboration — expressive, accurate English for your craft.",

            te_accent_title: "Accent and the way you talk",
            te_accent_subtitle:
                "Whether you are starting out or polishing an advanced level, we focus on intelligibility, rhythm, and the sounds that matter for you — so you feel heard, not \"corrected\" into sounding unlike yourself.",
            te_accent_p1_title: "Sound natural",
            te_accent_p1_desc: "Stress, linking, and melody of English sentences in real conversations.",
            te_accent_p2_title: "Speak with ease",
            te_accent_p2_desc: "Breathing, pace, and confidence for calls, classes, and daily life.",
            te_accent_p3_title: "All ages welcome",
            te_accent_p3_desc: "Engaging paths for children and structured coaching for adults and teams.",

            te_steps_title: "How it works",
            te_steps_subtitle: "Simple steps from first hello to your first lesson.",
            te_step1_title: "Tell us about you",
            te_step1_desc: "Goals, level, schedule, and whether you care most about accent, exams, or work English.",
            te_step2_title: "We match a teacher",
            te_step2_desc: "Specialists for your field when it matters — always with a human, supportive style.",
            te_step3_title: "Learn live online",
            te_step3_desc: "Sessions that fit your time zone; practice you can use the same day.",

            te_enroll_title: "Ready to begin?",
            te_enroll_subtitle:
                "Answer a few questions in our form — level, goals, and availability. We read every response personally.",
            te_enroll_btn: "Open registration form",
            te_whatsapp_fab_aria: "Chat on WhatsApp",
            te_whatsapp_hint: "Prefer WhatsApp? Tap the green button anytime.",

            te_footer_line: "Tutti English — online English with heart and rigor.",
            te_footer_rights: "All rights reserved.",

            te_register_title: "Schedule your first class",
            te_register_subtitle:
                "Share a few details so we can get in touch with the best time for your trial lesson.",
            te_register_back: "Back to home",
            te_register_name: "Full name",
            te_register_name_ph: "Your name",
            te_register_phone: "Phone number",
            te_register_phone_ph: "Including country code if outside the US",
            te_register_email: "Email address",
            te_register_email_ph: "you@example.com",
            te_register_date: "When could you start?",
            te_register_date_help: "Pick the earliest date that works — we’ll confirm availability.",
            te_register_expectations: "What do you expect to learn?",
            te_register_expectations_ph:
                "e.g. conversational English, pronunciation, exams, workplace English…",
            te_register_submit: "Submit registration",
            te_register_validation: "Please fill in every field before submitting.",
            label_required_field: "This field is required.",
            te_char_count: "{{used}} / {{max}} characters · {{left}} remaining",
            te_register_success: "Thanks — we received your registration and will contact you soon.",
            te_register_failed: "Something went wrong. Please try again.",

            placeholder_select_status: "Select status",
            placeholder_input_code: "Enter code",
            placeholder_input_name: "Enter name",
            placeholder_input_phone_number: "Enter phone number",
            placeholder_input_email_address: "Enter email address",
            placeholder_input_date_start: "Enter date start",
            placeholder_input_expectation: "Enter expectation",

            column_code: "CODE",
            column_name: "NAME",
            column_phone_number: "PHONE NUMBER",
            column_email_address: "EMAIL ADDRESS",
            column_date_start: "DATE START",
            column_expectation: "EXPECTATION",
            column_enable: "ENABLE",
            column_enable_label: "ENABLE LABEL",
            column_date_process: "DATE PROCESS",
            column_enable_yes: "YES",
            column_enable_no: "NO",

            btn_modify: "Modify",
            btn_disable: "Disable",
            btn_enable: "Enable",

            alert_proccesed_successfully: "Processed successfully",
            alert_process_failed: "Process failed",
            alert_are_you_sure_you_want_to_disable: "Are you sure you want to disable this applicant?",
            alert_are_you_sure_you_want_to_enable: "Are you sure you want to enable this applicant?",
            alert_disabled_successfully: "Disabled successfully",
            alert_enabled_successfully: "Enabled successfully",

            dev_profile_badge: "Software development",
            dev_profile_role: "Software Developer",
            dev_profile_subtitle: "Custom software solutions for businesses and individuals worldwide.",
            dev_profile_about:
                "I build reliable web applications, internal tools, and digital products tailored to your goals — from idea to deployment and ongoing support.",
            dev_profile_services_title: "What I offer",
            dev_profile_service_1: "Web applications & dashboards",
            dev_profile_service_2: "APIs, integrations & automation",
            dev_profile_service_3: "Maintenance, updates & technical consulting",
            dev_profile_contact_title: "Contact",
            dev_profile_company_email: "Business email",
            dev_profile_email: "Email",
            dev_profile_phone: "Phone",
            dev_profile_address: "Address",
            dev_profile_zip: "Zip code",
            dev_profile_cta_email: "Send an email",
            dev_profile_cta_phone: "Call",
            dev_profile_back: "Back to home",
        },
    },
    es: {
        translation: {
            label_inicio: "Inicio",
            label_contacto: "Contacto",
            label_iniciar_sesion: "Iniciar sesión",
            label_plataforma_de_nutricion: "Inglés para estudiantes de todo el mundo",
            label_ingresa_tus_credenciales_para_continuar: "Ingresa tus credenciales para continuar",
            label_usuario: "Usuario",
            label_ingresa_tu_usuario: "Ingresa tu usuario",
            label_contrasena: "Contraseña",
            label_ingresa_tu_contrasena: "Ingresa tu contraseña",
            label_ingresar: "Ingresar",
            label_volver_al_inicio: "Volver al inicio",
            label_cargando: "Cargando…",
            label_manage_applicant: "Gestionar candidatos",
            label_administra_la_lista_de_applicants: "Administra la lista de candidatos",
            label_nuevo: "Nuevo",
            label_buscar: "Buscar",
            label_estado: "Estado",
            label_showing: "Mostrando",
            label_of: "de",
            label_records: "registros",
            label_no_records: "Sin registros",
            label_previous: "Anterior",
            label_page: "Página",
            label_code: "Código",
            label_name: "Nombre",
            label_phone_number: "Teléfono",
            label_email_address: "Correo electrónico",
            label_date_start: "Fecha de inicio",
            label_expectation: "Expectativa",
            label_modify_applicant: "Modificar candidato",
            label_tuttie_english: "Tuttie English",

            alert_usuario_o_contrasena_incorrecto: "Usuario o contraseña incorrectos",
            alert_procesando_solicitud: "Procesando…",
            alert_fecha_invalida: "Ingresa una fecha válida.",
            cal_today: "Hoy",
            cal_placeholder_select: "Selecciona una fecha (MM-DD-YYYY)",

            menu_dashboard: "Panel",
            menu_administracion: "Administración",
            menu_applicants: "Candidatos",
            menu_salir: "Salir",

            te_brand: "Tutti English",
            te_nav_specialties: "Especialidades",
            te_nav_accent: "Acento y oralidad",
            te_nav_how: "Cómo funciona",
            te_nav_join: "Inscribirse",
            te_hero_badge: "Niños, adultos y profesionales",
            te_hero_title: "Aprende inglés —",
            te_hero_title_highlight: "acento claro, confianza real",
            te_hero_subtitle:
                "Clases en línea adaptadas a cómo hablas hoy y cómo quieres sonar mañana. Medicina, tecnología, arte y fluidez cotidiana — con docentes alineados a tus metas.",
            te_hero_cta_form: "Empezar con el formulario",
            te_hero_cta_whatsapp: "Escribir por WhatsApp",
            te_hero_secondary: "Ver especialidades",

            te_sectors_title: "Inglés que encaja en tu mundo",
            te_sectors_subtitle:
                "Te conectamos con profes que dominan el vocabulario y las situaciones que realmente usas — más allá del libro genérico.",
            te_sector_medical_title: "Medicina y salud",
            te_sector_medical_desc:
                "Pronunciación y lenguaje técnico para consultas, historias clínicas, equipo y comunicación con pacientes.",
            te_sector_it_title: "TI e ingeniería",
            te_sector_it_desc:
                "Dailies, documentación, entrevistas y llamadas con clientes — claridad y ritmo natural.",
            te_sector_music_title: "Música y creativos",
            te_sector_music_desc:
                "Estudio, giras, entrevistas y colaboración — inglés expresivo y preciso para tu oficio.",

            te_accent_title: "Acento y forma de hablar",
            te_accent_subtitle:
                "Si empiezas desde cero o quieres pulir un nivel avanzado, trabajamos inteligibilidad, ritmo y los sonidos que importan para ti — para que te sientas escuchado, no \"corregido\" hasta dejar de sonar como tú.",
            te_accent_p1_title: "Suena natural",
            te_accent_p1_desc: "Acento tónico, encadenado y melodía de frases en conversaciones reales.",
            te_accent_p2_title: "Habla con soltura",
            te_accent_p2_desc: "Respiración, velocidad y seguridad en llamadas, clases y vida diaria.",
            te_accent_p3_title: "Todas las edades",
            te_accent_p3_desc: "Rutas divertidas para niños y coaching estructurado para adultos y equipos.",

            te_steps_title: "Cómo funciona",
            te_steps_subtitle: "Pasos sencillos desde el primer hola hasta tu primera clase.",
            te_step1_title: "Cuéntanos de ti",
            te_step1_desc: "Metas, nivel, horario y si te importa más el acento, exámenes o inglés laboral.",
            te_step2_title: "Te asignamos un profe",
            te_step2_desc: "Especialistas en tu ámbito cuando hace falta — siempre con trato humano.",
            te_step3_title: "Aprende en vivo en línea",
            te_step3_desc: "Sesiones según tu zona horaria; práctica que puedes usar el mismo día.",

            te_enroll_title: "¿Listo para empezar?",
            te_enroll_subtitle:
                "Responde unas preguntas en nuestro formulario: nivel, objetivos y disponibilidad. Leemos cada mensaje.",
            te_enroll_btn: "Abrir formulario de inscripción",
            te_whatsapp_fab_aria: "Chatear por WhatsApp",
            te_whatsapp_hint: "¿Prefieres WhatsApp? Toca el botón verde cuando quieras.",

            te_footer_line: "Tutti English — inglés en línea con rigor y cercanía.",
            te_footer_rights: "Todos los derechos reservados.",

            te_register_title: "Agenda tu primera clase",
            te_register_subtitle:
                "Comparte algunos datos para contactarte con el mejor momento para tu clase de prueba.",
            te_register_back: "Volver al inicio",
            te_register_name: "Nombre completo",
            te_register_name_ph: "Tu nombre",
            te_register_phone: "Teléfono",
            te_register_phone_ph: "Con código de país si no estás en EE. UU.",
            te_register_email: "Correo electrónico",
            te_register_email_ph: "tu@ejemplo.com",
            te_register_date: "¿Cuándo podrías empezar?",
            te_register_date_help: "Elige la fecha más temprana que te funcione — confirmamos disponibilidad.",
            te_register_expectations: "¿Qué esperas aprender?",
            te_register_expectations_ph:
                "p. ej. inglés conversacional, pronunciación, exámenes, inglés laboral…",
            te_register_submit: "Enviar inscripción",
            te_register_validation: "Completa todos los campos antes de enviar.",
            label_required_field: "Este campo es obligatorio.",
            te_char_count: "{{used}} / {{max}} caracteres · {{left}} restantes",
            te_register_success: "Gracias — recibimos tu inscripción y te contactaremos pronto.",
            te_register_failed: "Algo salió mal. Inténtalo de nuevo.",

            placeholder_select_status: "Selecciona el estado",
            placeholder_input_code: "Ingresa el código",
            placeholder_input_name: "Ingresa el nombre",
            placeholder_input_phone_number: "Ingresa el número de teléfono",
            placeholder_input_email_address: "Ingresa el correo electrónico",
            placeholder_input_date_start: "Ingresa la fecha de inicio",
            placeholder_input_expectation: "Ingresa la expectativa",

            column_code: "CODIGO",
            column_name: "NOMBRE",
            column_phone_number: "TELÉFONO",
            column_email_address: "CORREO ELECTRÓNICO",
            column_date_start: "FECHA DE INICIO",
            column_expectation: "EXPECTATIVA",
            column_enable: "HABILITADO",
            column_enable_label: "HABILITADO LABEL",
            column_date_process: "FECHA DE PROCESO",
            column_enable_yes: "SI",
            column_enable_no: "NO",

            btn_modify: "Modificar",
            btn_disable: "Deshabilitar",
            btn_enable: "Habilitar",

            alert_proccesed_successfully: "Procesado correctamente",
            alert_process_failed: "Procesado fallido",
            alert_are_you_sure_you_want_to_disable: "¿Estás seguro de querer deshabilitar este candidato?",
            alert_are_you_sure_you_want_to_enable: "¿Estás seguro de querer habilitar este candidato?",
            alert_disabled_successfully: "Deshabilitado correctamente",
            alert_enabled_successfully: "Habilitado correctamente",

            dev_profile_badge: "Desarrollo de software",
            dev_profile_role: "Desarrollador de software",
            dev_profile_subtitle: "Soluciones de software a medida para empresas y clientes de todo el mundo.",
            dev_profile_about:
                "Creo aplicaciones web, herramientas internas y productos digitales confiables — desde la idea hasta el despliegue y el soporte continuo.",
            dev_profile_services_title: "Servicios",
            dev_profile_service_1: "Aplicaciones web y paneles",
            dev_profile_service_2: "APIs, integraciones y automatización",
            dev_profile_service_3: "Mantenimiento, actualizaciones y consultoría técnica",
            dev_profile_contact_title: "Contacto",
            dev_profile_company_email: "Correo comercial",
            dev_profile_email: "Correo",
            dev_profile_phone: "Teléfono",
            dev_profile_address: "Dirección",
            dev_profile_zip: "Código postal",
            dev_profile_cta_email: "Enviar correo",
            dev_profile_cta_phone: "Llamar",
            dev_profile_back: "Volver al inicio",
        },
    },
    pt: {
        translation: {
            label_inicio: "Início",
            label_contacto: "Contato",
            label_iniciar_sesion: "Entrar",
            label_plataforma_de_nutricion: "Inglês para alunos em todo o mundo",
            label_ingresa_tus_credenciales_para_continuar: "Insira suas credenciais para continuar",
            label_usuario: "Usuário",
            label_ingresa_tu_usuario: "Digite seu usuário",
            label_contrasena: "Senha",
            label_ingresa_tu_contrasena: "Digite sua senha",
            label_ingresar: "Entrar",
            label_volver_al_inicio: "Voltar ao início",
            label_cargando: "Carregando…",
            label_manage_applicant: "Gerenciar candidatos",
            label_administra_la_lista_de_applicants: "Administra a lista de candidatos",
            label_nuevo: "Nuevo",
            label_buscar: "Buscar",
            label_estado: "Estado",
            label_showing: "Mostrando",
            label_of: "de",
            label_records: "registros",
            label_no_records: "Sin registros",
            label_previous: "Anterior",
            label_page: "Página",
            label_code: "Código",
            label_name: "Nome",
            label_phone_number: "Número de telefone",
            label_email_address: "Endereço de e-mail",
            label_date_start: "Data de início",
            label_expectation: "Expectativa",
            label_modify_applicant: "Modificar candidato",
            label_tuttie_english: "Tuttie English",

            alert_usuario_o_contrasena_incorrecto: "Usuário ou senha incorretos",
            alert_procesando_solicitud: "Processando…",
            alert_fecha_invalida: "Insira uma data válida.",
            cal_today: "Hoje",
            cal_placeholder_select: "Selecione a data (MM-DD-YYYY)",

            menu_dashboard: "Painel",
            menu_administracion: "Administração",
            menu_applicants: "Candidatos",
            menu_salir: "Sair",

            te_brand: "Tutti English",
            te_nav_specialties: "Especialidades",
            te_nav_accent: "Sotaque e fala",
            te_nav_how: "Como funciona",
            te_nav_join: "Inscrever-se",
            te_hero_badge: "Crianças, adultos e profissionais",
            te_hero_title: "Aprenda inglês —",
            te_hero_title_highlight: "sotaque claro, confiança de verdade",
            te_hero_subtitle:
                "Aulas online sob medida para como você fala hoje e como quer soar amanhã. Saúde, tecnologia, arte e fluência do dia a dia — com professores alinhados aos seus objetivos.",
            te_hero_cta_form: "Começar pelo formulário",
            te_hero_cta_whatsapp: "Falar no WhatsApp",
            te_hero_secondary: "Ver especialidades",

            te_sectors_title: "Inglês que combina com o seu mundo",
            te_sectors_subtitle:
                "Conectamos você a professores que dominam o vocabulário e os cenários que você realmente usa — além do livro genérico.",
            te_sector_medical_title: "Medicina e saúde",
            te_sector_medical_desc:
                "Pronúncia e linguagem técnica para consultas, prontuários, equipe e comunicação com pacientes.",
            te_sector_it_title: "TI e engenharia",
            te_sector_it_desc:
                "Dailies, documentação, entrevistas e calls com clientes — clareza e ritmo naturais.",
            te_sector_music_title: "Música e criativos",
            te_sector_music_desc:
                "Estúdio, turnês, entrevistas e parcerias — inglês expressivo e preciso para o seu ofício.",

            te_accent_title: "Sotaque e jeito de falar",
            te_accent_subtitle:
                "Do iniciante ao avançado, focamos inteligibilidade, ritmo e os sons que importam para você — para que se sinta ouvido, não \"corrigido\" até deixar de soar como você.",
            te_accent_p1_title: "Soar natural",
            te_accent_p1_desc: "Ênfase, conexão e melodia de frases em conversas reais.",
            te_accent_p2_title: "Falar com leveza",
            te_accent_p2_desc: "Respiração, velocidade e segurança em chamadas, aulas e vida diária.",
            te_accent_p3_title: "Todas as idades",
            te_accent_p3_desc: "Trilhas lúdicas para crianças e coaching estruturado para adultos e equipes.",

            te_steps_title: "Como funciona",
            te_steps_subtitle: "Passos simples do primeiro oi até a sua primeira aula.",
            te_step1_title: "Conte sobre você",
            te_step1_desc: "Metas, nível, agenda e se o foco é sotaque, provas ou inglês profissional.",
            te_step2_title: "Combinamos um professor",
            te_step2_desc: "Especialistas da sua área quando importa — sempre com acolhimento humano.",
            te_step3_title: "Aprenda ao vivo online",
            te_step3_desc: "Horários no seu fuso; prática que você usa no mesmo dia.",

            te_enroll_title: "Pronto para começar?",
            te_enroll_subtitle:
                "Responda a um breve formulário: nível, objetivos e disponibilidade. Lemos cada resposta com atenção.",
            te_enroll_btn: "Abrir formulário de inscrição",
            te_whatsapp_fab_aria: "Conversar no WhatsApp",
            te_whatsapp_hint: "Prefere WhatsApp? Toque no botão verde quando quiser.",

            te_footer_line: "Tutti English — inglês online com rigor e afeto.",
            te_footer_rights: "Todos os direitos reservados.",

            te_register_title: "Agende sua primeira aula",
            te_register_subtitle:
                "Envie alguns dados para combinarmos o melhor horário para sua aula experimental.",
            te_register_back: "Voltar ao início",
            te_register_name: "Nome completo",
            te_register_name_ph: "Seu nome",
            te_register_phone: "Telefone",
            te_register_phone_ph: "Inclua código do país se não estiver nos EUA",
            te_register_email: "E-mail",
            te_register_email_ph: "voce@exemplo.com",
            te_register_date: "Quando você poderia começar?",
            te_register_date_help: "Escolha a data mais cedo que funcione para você — confirmamos a disponibilidade.",
            te_register_expectations: "O que você espera aprender?",
            te_register_expectations_ph:
                "ex.: inglês conversacional, pronúncia, provas, inglês corporativo…",
            te_register_submit: "Enviar inscrição",
            te_register_validation: "Preencha todos os campos antes de enviar.",
            label_required_field: "Este campo é obrigatório.",
            te_char_count: "{{used}} / {{max}} caracteres · {{left}} restantes",
            te_register_success: "Obrigado — recebemos sua inscrição e entraremos em contato em breve.",
            te_register_failed: "Algo deu errado. Tente novamente.",

            placeholder_select_status: "Selecione o estado",
            placeholder_input_code: "Digite o código",
            placeholder_input_name: "Digite o nome",
            placeholder_input_phone_number: "Digite o número de telefone",
            placeholder_input_email_address: "Digite o endereço de e-mail",
            placeholder_input_date_start: "Digite a data de início",
            placeholder_input_expectation: "Digite a expectativa",

            column_code: "CÓDIGO",
            column_name: "NOME",
            column_phone_number: "TELEFONE",
            column_email_address: "E-MAIL",
            column_date_start: "DATA DE INICIO",
            column_expectation: "EXPECTATIVA",
            column_enable: "HABILITADO",
            column_enable_label: "HABILITADO LABEL",
            column_date_process: "DATA DE PROCESO",
            column_enable_yes: "SIM",
            column_enable_no: "NÃO",

            btn_modify: "Modificar",
            btn_disable: "Deshabilitar",
            btn_enable: "Habilitar",

            alert_proccesed_successfully: "Procesado correctamente",
            alert_process_failed: "Procesado fallido",
            alert_are_you_sure_you_want_to_disable: "¿Estás seguro de querer deshabilitar este candidato?",
            alert_are_you_sure_you_want_to_enable: "¿Estás seguro de querer habilitar este candidato?",
            alert_disabled_successfully: "Deshabilitado correctamente",
            alert_enabled_successfully: "Habilitado correctamente",

            dev_profile_badge: "Desenvolvimento de software",
            dev_profile_role: "Desenvolvedor de software",
            dev_profile_subtitle: "Soluções de software sob medida para empresas e clientes em todo o mundo.",
            dev_profile_about:
                "Desenvolvo aplicações web, ferramentas internas e produtos digitais confiáveis — da ideia à implantação e suporte contínuo.",
            dev_profile_services_title: "Serviços",
            dev_profile_service_1: "Aplicações web e painéis",
            dev_profile_service_2: "APIs, integrações e automação",
            dev_profile_service_3: "Manutenção, atualizações e consultoria técnica",
            dev_profile_contact_title: "Contato",
            dev_profile_company_email: "E-mail comercial",
            dev_profile_email: "E-mail",
            dev_profile_phone: "Telefone",
            dev_profile_address: "Endereço",
            dev_profile_zip: "CEP",
            dev_profile_cta_email: "Enviar e-mail",
            dev_profile_cta_phone: "Ligar",
            dev_profile_back: "Voltar ao início",
        },
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
